import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const multiSwitchLabelFn = /* @__PURE__ */ createRecipe('multi-switch-label', {}, [])

const multiSwitchLabelVariantMap = {}

const multiSwitchLabelVariantKeys = Object.keys(multiSwitchLabelVariantMap)

export const multiSwitchLabel = /* @__PURE__ */ Object.assign(memo(multiSwitchLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'multiSwitchLabel',
  __getCompoundVariantCss__: multiSwitchLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: multiSwitchLabelVariantKeys,
  variantMap: multiSwitchLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, multiSwitchLabelVariantKeys)
  },
  getVariantProps: multiSwitchLabelFn.getVariantProps,
})